@if (!criteria.BusinessId) {
<brt-business-list (selected)="router.navigate([basePath, 'menu', $event.Id, 'item'])"></brt-business-list>
} @else {
<h5 *ngIf="isMainComponent">Menu Item List</h5>
<p-table #dt1 [value]="menuItems" dataKey="id" [rows]="20" [loading]="loading" [rowHover]="true"
  styleClass="p-datatable-gridlines" [paginator]="true"  [rowsPerPageOptions]="[10, 20, 50, 100, 500, 1000]"
  [totalRecords]="total" [globalFilterFields]="[]" responsiveLayout="scroll" [lazy]="true" (onLazyLoad)="load($event)"
  (onRowReorder)="setOrder()">
  <ng-template pTemplate="caption">
    <div class="flex sm:flex-row">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input pInputText type="text" #filter [(ngModel)]="criteria.Query" placeholder="Search Keyword" class="w-full"
          (ngModelChange)="load()" />
      </span>
      @if(menuId){
      <button pButton label="Declare new item to this menu" class="mx-2" icon="pi pi-plus"
        [routerLink]="[basePath, 'menu', criteria.BusinessId, menuId, 'add']"></button>
      <button pButton label="Add existing menu item" class="p-button-outlined mr-2" icon="pi pi-plus"
        (click)="menuItemSearch.toggle($event)"></button>
      <p-overlayPanel #menuItemSearch [showCloseIcon]="true" [style]="{ width: '450px' }">
        <p-autoComplete id="menuitem" [suggestions]="filteredMenuItems" (completeMethod)="searchMenuItem($event.query)"
          (onSelect)="addMenuItem($event.value); menuItemSearch.hide()" field="Id">
          <ng-template let-item pTemplate="item">
            <div class="tw-flex tw-gap-2">
              <strong>{{ item.Name }}</strong>
              @if(item.UI?.Image){
              <img class="tw-w-16 tw-rounded-lg tw-ms-auto" [src]="item.UI?.Image" alt="{{ item.Name }}" />
              }
            </div>
          </ng-template>
        </p-autoComplete>
      </p-overlayPanel>
      } @else {
      <button *ngIf="!menuId" pButton label="Declare new item" class="ml-2" icon="pi pi-plus"
        [routerLink]="[basePath, 'menu', criteria.BusinessId, 'item', 'add']"></button>
      }
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th *ngIf="menuId"></th>
      <th style="min-width: 12rem">Name</th>
      <th style="min-width: 12rem">Menu(s)</th>
      <th style="min-width: 12rem">Not Available Until</th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-menuItem let-index="rowIndex">
    <tr [pReorderableRow]="index">
      <td class="align-center" *ngIf="menuId">
        <span class="pi pi-bars" pReorderableRowHandle></span>
      </td>
      <td>
        <div class="tw-flex tw-items-end tw-gap-2">
          <strong>{{ menuItem.Name }}</strong>
          @if(menuItem.UI?.Image){
          <img class="tw-w-16 tw-rounded-lg tw-ms-auto" [src]="menuItem.UI?.Image" alt="{{ menuItem.Name }}" />
          }
        </div>
      </td>
      <td>
        <div class="flex align-items-center justify-content-between gap-2">
          <ng-container *ngIf="menuId && !menuItem._loading">
            <span class="tw-text-sm">
              @if (!menuItem.MenuIds?.length) { <i class="pi pi-ban"></i> Not used
              in any menu } @else if (menuItem.MenuIds.includes(menuId)) {
              <i class="pi pi-check"></i>
              @if (menuItem.MenuIds?.length == 1) { Used in this menu } @else{
              Used in this menu and {{ menuItem.MenuIds.length }} other menu(s) }
              } @else if(menuId) { <i class="pi pi-minus"></i> Used in
              {{ menuItem.MenuIds.length }} other menu(s) } @else {
              <i class="pi pi-minus"></i> Used in
              {{ menuItem.MenuIds.length }} menu(s) }
            </span>
            <button *ngIf="!menuItem.MenuIds?.includes(menuId)" pButton [text]="true" class="p-button-success"
              icon="pi pi-plus" title="Add to Menu" [rounded]="true" (click)="toggleItemInMenu(menuItem)"></button>
            <button *ngIf="menuItem.MenuIds?.includes(menuId)" pButton class="p-button-danger p-button-text"
              icon="pi pi-times" title="Remove from Menu" [rounded]="true"
              (click)="toggleItemInMenu(menuItem)"></button>
          </ng-container>
        </div>
      </td>
      <td>
        <div class="flex align-items-center justify-content-between gap-2">
          {{ menuItem.NotAvailableUntil | date : "short" }}
          <button *ngIf="menuItem.NotAvailableUntil" title="Make it available now" pButton icon="pi pi-times"
            class="p-button-danger p-button-text" [rounded]="true"
            (click)="setNotAvaialbeUntil(menuItem, null)"></button>
        </div>
      </td>
      <td>
        <div class="flex align-items-center justify-content-center gap-2">
          <p-menu #actionMenu [model]="menuItem._actions" [popup]="true" appendTo="body"></p-menu>
          <button pButton [id]="'action-menu-' + menuItem.Id" type="button" (click)="actionMenu.toggle($event)"
            icon="pi pi-ellipsis-h"></button>

          <button (click)="notAvaialbeUntilPanel.toggle($event)" pButton icon="pi pi-calendar"
            title="Not Available Until" class="p-button-secondary"></button>
          <p-overlayPanel #notAvaialbeUntilPanel [showCloseIcon]="true" [style]="{ width: '400px' }">
            <p-calendar #notAvailableUntil [(ngModel)]="menuItem.NotAvailableUntil" [inline]="true" [showTime]="true"
              [showButtonBar]="true" [showOnFocus]="false" class="w-full border-none"></p-calendar>
            <div class="tw-flex tw-mt-2 tw-items-center tw-justify-between">
              <button pButton pRipple label="Save" (click)="
                  setNotAvaialbeUntil(menuItem, notAvailableUntil.value);
                  notAvaialbeUntilPanel.toggle($event)
                "></button>
              {{ menuItem.NotAvailableUntil | json }}
            </div>
          </p-overlayPanel>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="8">No menu item found.</td>
    </tr>
  </ng-template>
  <ng-template pTemplate="loadingbody">
    <!-- <tr>
      <td colspan="8">Loading menu item data. Please wait.</td>
    </tr> -->
    <tr>
      <td><p-skeleton /></td>
      <td><p-skeleton /></td>
      <td><p-skeleton /></td>
      <td><p-skeleton /></td>
    </tr>
    <tr>
      <td><p-skeleton /></td>
      <td><p-skeleton /></td>
      <td><p-skeleton /></td>
      <td><p-skeleton /></td>
    </tr>
    <tr>
      <td><p-skeleton /></td>
      <td><p-skeleton /></td>
      <td><p-skeleton /></td>
      <td><p-skeleton /></td>
    </tr>
  </ng-template>
</p-table>

<p-confirmPopup key="confirmPopup"></p-confirmPopup>
}